interface PuzzleSvgProps {
  color: string;
  style: React.CSSProperties;
}

const PuzzleSvg = ({ color, style }: PuzzleSvgProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="45"
    height="50"
    viewBox="0 0 45 50"
    fill="none"
  >
    <g clipPath="url(#clip0_465_13765)">
      <path
        d="M21.8604 13.9844H23.3472"
        stroke={color}
        strokeWidth="1.12518"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.8604 17.2091H23.3472"
        stroke={color}
        strokeWidth="1.12518"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.8604 20.4341H23.3472"
        stroke={color}
        strokeWidth="1.12518"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.86523 17.2091H11.3521"
        stroke={color}
        strokeWidth="1.12518"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.86523 20.4341H11.3521"
        stroke={color}
        strokeWidth="1.12518"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.8311 22.4633V23.9601"
        stroke={color}
        strokeWidth="1.12518"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6064 22.4633V23.9601"
        stroke={color}
        strokeWidth="1.12518"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3813 22.4633V23.9601"
        stroke={color}
        strokeWidth="1.12518"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.8311 10.4681V11.965"
        stroke={color}
        strokeWidth="1.12518"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6064 10.4681V11.965"
        stroke={color}
        strokeWidth="1.12518"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9034 13.9844C15.9034 15.4109 14.7481 16.5763 13.3115 16.5763V20.434H19.7612V13.9844H15.9034Z"
        stroke={color}
        strokeWidth="1.12518"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.145 32.1078L27.1651 22.4333C27.1651 22.0415 27.3861 21.6898 27.7377 21.5191C27.8784 21.4487 28.0291 21.4086 28.1898 21.4086C28.4108 21.4086 28.6318 21.4789 28.8026 21.6195C29.3853 22.0616 30.0986 22.3027 30.8119 22.3027C31.8968 22.3027 32.7809 21.4186 32.7809 20.3236V18.7965C32.7809 17.7015 31.8968 16.8174 30.8119 16.8174C30.0986 16.8174 29.3752 17.0585 28.8026 17.5006C28.5012 17.7316 28.0692 17.7718 27.7377 17.601C27.3861 17.4303 27.1651 17.0786 27.1651 16.6868L27.1249 6.942C27.1249 6.65066 26.924 6.38946 26.6125 6.289C26.5121 6.23877 26.4217 6.21868 26.3212 6.21868L16.5764 6.17849C16.1846 6.17849 15.833 5.95747 15.6622 5.60586C15.4914 5.25424 15.5316 4.8323 15.7727 4.53091C16.2147 3.95828 16.4558 3.245 16.4558 2.52167C16.4558 1.43668 15.5717 0.552612 14.4767 0.552612H12.9497C11.8547 0.552612 10.9706 1.43668 10.9706 2.52167C10.9706 3.245 11.2117 3.95828 11.6537 4.53091C11.8848 4.8323 11.935 5.25424 11.7642 5.60586C11.5934 5.95747 11.2418 6.17849 10.85 6.17849L1.24585 6.19858C0.87414 6.19858 0.572754 6.49997 0.572754 6.87168V16.7069C0.612939 16.8576 0.703355 16.9983 0.844002 17.0686C1.01479 17.149 1.21571 17.1289 1.35636 17.0184C2.01941 16.506 2.8432 16.2247 3.68708 16.2247C5.06341 16.2247 6.18859 17.3499 6.18859 18.7262V20.2633C6.18859 21.6497 5.06341 22.7648 3.68708 22.7648C2.8432 22.7648 2.01941 22.4835 1.35636 21.9711C1.21571 21.8606 1.00474 21.8405 0.844002 21.9209C0.703355 21.9812 0.602893 22.1218 0.5828 22.2625V32.1078H27.155H27.145Z"
        stroke={color}
        strokeWidth="1.12518"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.4082 17.2091H37.7034C38.0751 17.2091 38.3765 17.5105 38.3765 17.8822L38.3966 27.4864C38.3966 27.8782 38.6176 28.2298 38.9692 28.4006C39.3108 28.5714 39.7327 28.5312 40.0441 28.2901C40.6168 27.848 41.3301 27.6069 42.0534 27.6069C43.1384 27.6069 44.0325 28.491 44.0325 29.586V31.1131C44.0325 32.2081 43.1484 33.0922 42.0534 33.0922C41.3301 33.0922 40.6268 32.8511 40.0441 32.409C39.7428 32.1679 39.3208 32.1277 38.9692 32.2985C38.6176 32.4693 38.3966 32.8209 38.3966 33.2127L38.3564 42.9575C38.3564 43.058 38.3363 43.1484 38.2861 43.2489C38.1856 43.5603 37.9244 43.7612 37.633 43.7612L27.8882 43.8014C27.4964 43.8014 27.1448 44.0224 26.974 44.3741C26.8032 44.7156 26.8434 45.1376 27.0745 45.439C27.5165 46.0216 27.7576 46.7349 27.7576 47.4482C27.7576 48.5332 26.8736 49.4173 25.7785 49.4173H24.2515C23.1665 49.4173 22.2724 48.5332 22.2724 47.4482C22.2724 46.7349 22.5135 46.0116 22.9555 45.439C23.0861 45.2682 23.1665 45.0472 23.1665 44.8261C23.1665 44.6654 23.1364 44.5147 23.056 44.3741C22.8953 44.0325 22.5336 43.8014 22.1418 43.8014L12.4673 43.7813V34.3379"
        stroke={color}
        strokeWidth="1.12518"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_465_13765">
        <rect width="44.5851" height="50" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default PuzzleSvg;
